import { render, staticRenderFns } from "./PublicFilesEditor.vue?vue&type=template&id=602647cd&"
import script from "./PublicFilesEditor.vue?vue&type=script&lang=js&"
export * from "./PublicFilesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports